import {Observable} from 'rxjs';
import {ItemUpdatedResponse} from '../../entities';
import {map} from 'rxjs/operators';
import {PatientStatus} from './entities';
import {PatientStatusCollectionResponse} from './entities';
import {inject, Injectable} from '@angular/core';
import {ApiService} from '../base';
import {AdminApiService} from '../base';
import {ItemCreatedResponse} from '../../entities';
import {ItemDeletedResponse} from '../../entities';

@Injectable({
  providedIn: 'root'
})
export class PatientStatusRepositoryService {
  private api = inject(ApiService);
  private adminApi = inject(AdminApiService);

  loadStatuses(): Observable<PatientStatus[]> {
    return this.api.get<PatientStatusCollectionResponse>('/patients/statuses')
      .pipe(map(response => response.items));
  }
  adminLoadStatuses(): Observable<PatientStatus[]> {
    return this.adminApi.get<PatientStatusCollectionResponse>('/patientstatus')
      .pipe(map(response => response.items));
  }

  adminCreate(status: PatientStatus): Observable<number> {
    return this.adminApi.post<ItemCreatedResponse>('/patientstatus', status)
      .pipe(map(response => response.value));
  }

  adminUpdate(id: number, status: PatientStatus): Observable<boolean> {
    return this.adminApi.put<ItemUpdatedResponse>('/patientstatus/' + id, status)
      .pipe(map(response => response.status.toLocaleUpperCase() === 'OK'));
  }

  adminDelete(id: number): Observable<boolean> {
    return this.adminApi.delete<ItemDeletedResponse>('/patientstatus/' + id)
      .pipe(map(response => response.status.toLocaleUpperCase() === 'OK'));
  }
}
